import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';

interface State {
    active: number;
    createdAt: any;
    name: string;
    updatedAt: any;
}

interface StateId extends State {
    id: string;
}

@Injectable()
export class StateService {

    stateCollection: AngularFirestoreCollection<State>;
    states: any;

    stateDocument: AngularFirestoreDocument<StateId>;
    state: Observable<StateId>;

    collection: string;

    constructor(private afs: AngularFirestore) {
        this.collection = Globals.STATE_COLLECTION;
    }

    postState(stateObject: any) {
        this.stateCollection = this.afs.collection(this.collection);

        return this.stateCollection.add(stateObject).then(function(docRef) {
            // console.log('Document added with ID: ', docRef.id);
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
        });
    }

    postStateWithId(stateObject: any, id$: string) {
        this.stateCollection = this.afs.collection(this.collection);

        return this.stateCollection.doc(id$).set(stateObject).then(function(docRef) {
            // console.log('Document added with ID: ', docRef.id);
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
        });
    }

    getStates() {
        this.stateCollection = this.afs.collection(this.collection, ref => ref.orderBy('name'));

        this.states = this.stateCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as State;

                const name = data.name;

                return { id$, name };
            });
        }).map(object => object);

        return this.states;
    }

    getState(id$: string) {
        this.stateDocument = this.afs.doc(this.collection + '/' + id$);

        this.state = this.stateDocument.valueChanges();

        return this.state.map(object => object);
    }

    putState(stateObject: any, id$: string) {
        this.stateCollection = this.afs.collection(this.collection);

        return this.stateCollection.doc(id$).update(stateObject).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

    delState(id$: string) {
        if(!confirm('¿Desea eliminar?')) return;
        this.stateDocument = this.afs.doc(this.collection + '/' + id$);

        return this.stateDocument .delete().then(function() {
            // console.log('Document deleted');
        }).catch(function(error) {
            // console.error('Error deleting document: ', error);
        });
    }

}
